function navHandle() {
  /* OPEN NAVIGATION */
  var navbutton = document.getElementById("button__navigation");
  var navigation = document.getElementById("navigation");
  var links = navigation.querySelectorAll("a");
  var searchButton = document.getElementById("button__search");
  var searchArea = document.getElementById("search-menu");
  var closeWarningButton = document.getElementById("close_warning");
  var warningbar = document.getElementById("warningbar");

  navbutton.addEventListener("click", () => {
    navigation.classList.toggle("navigation--visible");
    navbutton.classList.toggle("navigation--visible");

    navbutton.innerHTML = navbutton.classList.contains("navigation--visible")
      ? "LUK"
      : "MENU";

    if (navbutton.classList.contains("navigation--visible")) {
      searchArea.classList.remove("search-menu--visible");
      searchButton.classList.remove("button__search--open");
      navigation.setAttribute("tabindex", "0");
      updateLinksTabIndex(links, "0");
    } else {
      navigation.setAttribute("tabindex", "-1");
      updateLinksTabIndex(links, "-1");
    }
  });

  function updateLinksTabIndex(links, value) {
    links.forEach(function (link) {
      link.setAttribute("tabindex", value);
    });
  }

  /* EXPAND NAVIGATION */
  var navExpandButtons = document.querySelectorAll(".navigation__expand-li");
  if (navExpandButtons) {
    navExpandButtons.forEach(function (navExpansions) {
      navExpansions.children[0].addEventListener("click", () => {
        expandNavigationAccordions(navExpansions);
      });
    });
  }

  function expandNavigationAccordions(navs) {
    // navExpandButtons.forEach(li => {
    //     if (li.classList.contains("navigation__expand-li--expanded")) {
    //         li.classList.remove("navigation__expand-li--expanded");
    //     }
    // });
    navs.classList.toggle("navigation__expand-li--expanded");
  }

  /* WARNING BAR */
  closeWarningButton.addEventListener("click", () => {
    warningbar.classList.remove("visible");
    localStorage.setItem("popupClosed", "true");
    localStorage.setItem("popupClosedTime", new Date().getTime());
  });

  // Check if the warningbar was closed
  var isPopupClosed = localStorage.getItem("popupClosed") === "true";

  // Check if enough time has passed (e.g., 5 minutes)
  var currentTime = new Date().getTime();
  var closedTime = localStorage.getItem("popupClosedTime");
  var timeSinceClosed = currentTime - closedTime;
  var isEnabledFromUmbraco = warningbar.classList.contains("enabled");
  var minutesToPass = parseFloat(warningbar.getAttribute('data-reappear'));

  if (isEnabledFromUmbraco) {
    if (!isPopupClosed || timeSinceClosed > minutesToPass * 60 * 1000) {
      // vis popup
      document.getElementById("warningbar").classList.add("visible");
    } 
  } 
}
